import { type CSSProperties } from 'react';
import type { AvatarData } from '@/api';
import { cn } from '@/utils';
import { buildAvatarSpriteLayers } from '../avatarSpriteLayers';
import S from './AnimatedAvatar.module.scss';

/**
 * 코어 `@zep/ui` Avatar 를 quiz-app 으로 1:1 포팅한 애니메이션 아바타.
 * stand(정지)/walk/dance 모션을 동일하게 재현한다 (AnimatedAvatar.module.scss).
 *
 * 파츠 레이어 조합(순서/URL/정규화)은 `avatarSpriteLayers` 로 공통화했고, 여기선
 * scss 스프라이트 애니메이션(`--image-url`)만 담당한다.
 * 네이티브 48×64 로 렌더되므로 호출부에서 scale 로 키운다(코어 모달과 동일).
 */
export type AvatarBehavior = 'stand' | 'walk' | 'dance';
export const AnimatedAvatar = ({
  avatarData,
  behavior = 'stand',
  className
}: {
  avatarData: AvatarData;
  behavior?: AvatarBehavior;
  className?: string;
}) => {
  const layers = buildAvatarSpriteLayers(avatarData);
  return <div className={cn(S.character, S.front, {
    [S.stand]: behavior === 'stand',
    [S.walk]: behavior === 'walk',
    [S.dance]: behavior === 'dance'
  }, className)} data-sentry-component="AnimatedAvatar" data-sentry-source-file="AnimatedAvatar.tsx">
      {layers.map(({
      part,
      url
    }) => <span key={part} className={S.object} style={{
      '--image-url': `url(${url})`
    } as CSSProperties} aria-hidden="true" />)}
    </div>;
};